import React, { useEffect, useState } from "react";
import StrategiesAPI from "../api/StrategiesAPI";
import { useParams } from "react-router-dom";
import { toImagePath } from "../utils/globalFunctions";

function Strategies() {
  const [details, setDetails] = useState([]);
  const { id } = useParams();
  const numericId = parseInt(id) || 1;

  const fetchData = async () => {
    try {
      const response = await StrategiesAPI.getStrategy();
      const data = response.data;
      setDetails(data);
    } catch (error) {
      console.log("ContactAPI.getStrategies", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <main className="site-main">
      <section className="banner bg-news-intro">
        <img className="banner-image w-full" src="/images/standards/bg-standards.jpeg" alt="Hero Banner" />
        <div className="headline text-center">
          <h1 className="headline-title text-3xl md:text-6xl font-bold text-white">{details.title}</h1>
        </div>
      </section>
      {/* Main Content */}
      <section className="content p-4 md:p-8 bg-gray-50">
        <div className="content-container box-news-container">
          <div className="content-header w-full">
            <div className="header-content">
              <h2 className="header-content__title">
                {details.substrategy?.filter(item => item.order === numericId).map((item, index) =>
                  <div key={index} className="header-content__item">{item.title}</div>
                )}
              </h2>
            </div>

            {/* Section: About Office */}
            <section className="about-office mb-6 md:mb-8">
              <div className="relative">
                {details.substrategy?.filter(item => item.order === numericId).map((item, index) =>
                  <div key={index} className="shadow-lg rounded-lg">
                    <img className="img-aspect-video" src={toImagePath(item.image.path)} alt="" />
                  </div>
                )}
              </div>
              <div className="flex flex-col justify-center gap-3 items-center mt-5">
                {details.substrategy
                  ?.filter(item => item.order === numericId)
                  .map((item, index) => (
                    item.docfile.map((doc, docIndex) => (
                      <div key={`${index}-${docIndex}`} className="cursor-point"  onClick={() => window.open(toImagePath(doc.path), "_blank")}>
                        <button
                          key={`${index}-${docIndex}`}
                          className="flex items-center shadow-lg rounded-md p-4 bg-white border border-gray-200 hover:bg-gray-100 transition-all"
                        >
                          <img
                            src="/images/icons/pdf.svg"
                            alt="PDF Icon"
                          />
                          <h5 className="text-blue-900 font-medium pl-2">
                            {doc.title || "Untitled"}
                          </h5>
                        </button>
                      </div>
                    ))
                  ))}
              </div>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Strategies;